/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'

import { useBackgroundStyle } from '../../utils/styles/background'
import { useBorderStyle } from '../../utils/styles/border'
import { useMarginStyle } from '../../utils/styles/margin'
import { useSizeStyle } from '../../utils/styles/size'

const Placeholder = props => {
  const style = css`
    @keyframes load {
      from {
        left: -150px;
      }
      to {
        left: 100%;
      }
    }

    ${useSizeStyle({ minHeight: 0.5, ...props })}
    ${useBackgroundStyle({ bgColor: 'light1', ...props })}
    ${useBorderStyle({ radius: 0.5, ...props })}
    ${useMarginStyle(props)}

    box-shadow: 0 2px 5px 0 rgba(33, 33, 33, 0.05);
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      display: block;
      position: absolute;
      left: -150px;
      top: 0;
      height: 100%;
      width: 150px;
      background: linear-gradient(to right, transparent 0%, #f8f8f8 50%, transparent 100%);
      animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
    }
  `

  return <div class="placeholder" css={style}></div>
}

export default Placeholder
